import { render, staticRenderFns } from "./TransferAccountMain.vue?vue&type=template&id=6118d96c&"
import script from "./TransferAccountMain.vue?vue&type=script&lang=js&"
export * from "./TransferAccountMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports